import apiUser from "../../apiUser";

export const ADD = 'Suppliers/ADD';
export const SET = 'Suppliers/SET';
export const UPDATE = 'Suppliers/UPDATE';

export function setSuppliers(suppliers) {
  return {
    type: SET,
    suppliers
  }
}
export function addSupplier(supplier) {
  return {
    type: ADD,
    supplier
  }
}
export function updateSupplier(supplier) {
  return {
    type: UPDATE,
    supplier
  }
}

export function getSuppliers(){
  return dispatch => {
    return apiUser.suppliers.search({}, {
      sortOrder: 'asc',
      sortField: 'id',
    })
      .then(data => {
        dispatch(setSuppliers(data.data));

        return data;
      })
  }
}